module.exports = __webpack_public_path__ + "static/media/TTT.c9f6d197.svg";